import { render, staticRenderFns } from "./ExitToApp.vue?vue&type=template&id=378b9900&"
import script from "./ExitToApp.vue?vue&type=script&lang=js&"
export * from "./ExitToApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports